<template>
  <form>
    <div class="row mb-2">
      <div class="col-sm-12">

        <div class="row mt-2">
          <label for="source" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.source") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`source`)">
              <input :readonly="!!form.id" :class="parentProps.class" v-model="form.source"
                     v-maska
                     data-maska="A"
                     data-maska-tokens="A:[0-9a-zA-Z_]:multiple"
                     type="text" class="form-control" id="source">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="name" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.title") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`name`)">
              <input :class="parentProps.class" v-model="form.name" type="text" class="form-control " id="name">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="fromCurrency" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.from_currency") }}</label>
          <div class="col-sm-8">
            <Multiselect id="fromCurrency"
                         class=""
                         v-model="form.fromCurrency"
                         :options="currencies"
                         :custom-label="(opt) => `${opt}`"
                         :multiple="false"
                         select-label="Select"
                         placeholder=""
            >
            </Multiselect>
          </div>
        </div>

        <div class="row mt-2">
          <label for="toCurrency" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.to_currency") }}</label>
          <div class="col-sm-8">
            <Multiselect id="toCurrency"
                         class=""
                         v-model="form.toCurrency"
                         :options="currencies"
                         :custom-label="(opt) => `${opt}`"
                         :multiple="false"
                         select-label="Select"
                         placeholder=""
            >
            </Multiselect>
          </div>
        </div>

        <div v-if="canSetRateValue" class="row mt-2">
          <label for="rate" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.rate") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`rate`)">
              <input :class="parentProps.class" v-model="form.rate" type="text" class="form-control " id="rate">
            </FormInputWrapper>
          </div>
        </div>


      </div>
    </div>
  </form>
</template>

<script lang="ts">
import {defineComponent, toRefs, reactive, computed, PropType, Prop, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import CurrencyRateDTO from "@/models/CurrencyRateDTO";
import {api} from "@/service/APIClient";
import Multiselect from "vue-multiselect";

const components = {
  FormInputWrapper,
  Multiselect
}

export default defineComponent({
  components,
  setup(props) {
    const store = useStore();
    const state = reactive({
      errors: {} as ValidationErrorDTO[]|any,
      form: {} as CurrencyRateDTO,
    });

    const setErrors = (data: ValidationErrorDTO[]) => {
      state.errors = {};
      for (const error of data) {
        if (!state.errors.hasOwnProperty(error.field)) {
          state.errors[error.field] = [];
        }
        state.errors[error.field].push(error)
      }
    }

    const save = (): Promise<any> => {
      setErrors([]);
      const form = getForm();

      const data = {
        source: form.source,
        name: form.name,
        from: form.fromCurrency,
        to: form.toCurrency,
        rate: form.rate,
      }

      let promise;
      if (form.id) {
        promise = api.currencyRatesUpdate(form.id, data)
          .then((resp) => {
            return resp;
          })
      } else {
        promise = api.currencyRatesCreate(data)
          .then((resp) => {
            return resp;
          })
      }

      promise
        .catch((e: any) => {
          if (e.response && e.request && e.request.status === 400 && e.response.data) {
            setErrors(e.response.data)
          } else {
            console.log(e);
          }

        })

      return promise
    }

    const getErrors = (path: string) => {
      if (!state.errors.hasOwnProperty(path)) {
        return [];
      }

      return state.errors[path]
    }

    const hasErrors = (path: string) => {
      return state.errors[path]?.length > 0
    }

    const getForm = (): CurrencyRateDTO => {
      return state.form
    }

    const setForm = (form: CurrencyRateDTO) => {
      state.errors = {}
      state.form = {
        ...form,
      }
    }

    const currencies = computed(() => {
      let list = store.getters['currencyMethods/currencies']
      list.push('USDT')
      return list
    })

    const canSetRateValue = computed(() => {
      if (!state.form.id) {
        return true
      }

      if (state.form.source === 'manual' || state.form.source === 'manual_azn') {
        return true
      }

      return !!store.getters.getAppData?.MANUAL_CURRENCY_RATES_ENABLED
    })


    onMounted(() => {
    })


    return {
      ...toRefs(state),
      getForm,
      setForm,
      store,
      helper,
      numberFormatter,
      setErrors,
      getErrors,
      hasErrors,
      currencies,
      canSetRateValue,
      save,
    }
  }
})
</script>
